import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/archivo",
    component: MasterLayout,
    children: [
      {
        path: "aportes",
        name: "archivo.aportes",
        component: () => import("@/views/archivo/aportes/index.vue")
      },
      {
        path: "retiros",
        name: "archivo.retiros",
        component: () => import("@/views/archivo/retiros/index.vue")
      },
    ]
  }
]